import { ReactNode } from "react";
import { Outlet } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { AnimatePresence } from "motion/react";
import { Loader } from "@themes/pollinator/ui/Loader";
import { MotionFade } from "@themes/pollinator/ui/MotionFade";

export type Props = {
  title: string;
  isLoading: boolean;
  header?: ReactNode;
};

export const FlowLayout = ({ title, isLoading, header }: Props) => {
  return (
    <>
      <Helmet>
        <title>{["Pollinator", title].filter(Boolean).join(" | ")}</title>
      </Helmet>
      <div className="fixed inset-0 bg-brand-800" />
      <AnimatePresence mode="wait">
        {isLoading ? (
          <MotionFade
            key="loading"
            className="fixed inset-0 flex items-center justify-center"
          >
            <Loader innerClassName="text-brand-100" />
          </MotionFade>
        ) : (
          <MotionFade
            key="content"
            className="relative flex flex-col h-full w-full mx-auto min-h-screen"
          >
            {header}
            <main className="flex-grow flex flex-col h-full w-full mx-auto md:flex-row">
              <Outlet />
            </main>
          </MotionFade>
        )}
      </AnimatePresence>
    </>
  );
};

export default FlowLayout;
